import { types } from 'mobx-state-tree';

export const ITEM_STATUS = {
  notStarted: 'not_started',
  inProgress: 'in_progress',
  complete: 'complete',
};

export const COMPLETION_STATUS = {
  complete: 'complete',
  reopened: 'reopened',
};

const CompletionSummary = types.model('CompletionSummary', {
  text: types.string,
  createdAt: types.Date,
  createdBy: types.maybeNull(types.string),
});

const CompletionEvent = types.model('CompletionEvent', {
  status: types.string,
  changedAt: types.Date,
  changedBy: types.maybeNull(types.string),
  summary: types.maybeNull(CompletionSummary),
});

const Completion = types.model('Completion', {
  itemId: types.string,
  type: types.string,
  status: types.string,
  changedAt: types.Date,
  changedBy: types.maybeNull(types.string),
  summary: types.maybeNull(CompletionSummary),
  history: types.optional(types.array(CompletionEvent), []),
});

const summaryToJS = (summary) =>
  summary
    ? {
        text: summary.text,
        createdAt: summary.createdAt.toDate(),
        createdBy: summary.createdBy?.id || null,
      }
    : null;

export const completionToJS = (itemId, completion) => ({
  itemId,
  type: completion.type,
  status: completion.status,
  changedAt: completion.changedAt.toDate(),
  changedBy: completion.changedBy?.id || null,
  summary: summaryToJS(completion.summary),
  history: (completion.history || []).map((event) => ({
    status: event.status,
    changedAt: event.changedAt.toDate(),
    changedBy: event.changedBy?.id || null,
    summary: summaryToJS(event.summary),
  })),
});

export default Completion;
